import React from 'react';
import { Button } from 'antd';
import { Pencil, Store } from 'lucide-react';
import { CollapsibleCard } from '../../../common';
import AuditorStoreTable from './AuditorStoreTable';
import AuditorStoresModal from './StoreModal';
import { useAuditorStores } from './auditorStores.controller';

function AuditorStores({ stores, auditorId, updateStores }) {
    const [isOpen, setIsOpen] = React.useState(false);
    const auditorStores = useAuditorStores(stores, auditorId);

    return (
        <>
            <CollapsibleCard
                flush
                title="Pisos de Venta"
                description={`${auditorStores.length} asignados a este auditor`}
                icon={<Store />}
                extra={
                    <Button icon={<Pencil />} onClick={() => setIsOpen(true)}>
                        Editar pisos
                    </Button>
                }>
                <AuditorStoreTable stores={auditorStores} />
            </CollapsibleCard>
            <AuditorStoresModal isOpen={isOpen} userId={auditorId} setIsOpen={setIsOpen} allStores={stores} updateStores={updateStores} />
        </>
    );
}

export default AuditorStores;
